import ValueInterface from "../../../Model/Value/ValueInterface"
import { signs, DivisionSign } from "../../../Model/Value/DivisionValue"
import NumberValue from "../../../Model/Value/NumberValue"
import RandomNumberGenerator from "../../RandomNumberGenerator"
import ValueGeneratorInterface from "../ValueGeneratorInterface"
import EquationValue, {
  variables,
  VariableType,
} from "../../../Model/Value/EquationValue"
import BracketedValue from "../../../Model/Value/BracketedValue"

type BracketPosition = "left" | "right"

export default class DivisionExpressionValueGenerator implements ValueGeneratorInterface {
  constructor(
    private readonly randomNumberGenerator: RandomNumberGenerator,
    private readonly leftValueGenerator: ValueGeneratorInterface,
    private readonly rightValueGenerator: ValueGeneratorInterface,
    private readonly bracketsPosition: BracketPosition,
  ) {}

  public supports(value: number): boolean {
    return value !== 0
  }

  public generate(value: number, level: number): ValueInterface {
    const b: number = this.randomNumberGenerator.randomInt(
      3,
      Math.round(Math.sqrt(value)),
    )
    const a: number = b * value

    const aValue: ValueInterface = this.leftValueGenerator.generate(a, level)
    const bValue: ValueInterface = this.rightValueGenerator.generate(b, level)
    const divisionSign: DivisionSign =
      this.randomNumberGenerator.pick<DivisionSign>(signs)

    return new EquationValue(
      this.bracketsPosition === "left" ? new BracketedValue(aValue) : aValue,
      new NumberValue(value),
      this.bracketsPosition === "right" ? new BracketedValue(bValue) : bValue,
      this.randomNumberGenerator.pick<VariableType>(variables),
      `a ${divisionSign} b`,
    )
  }
}
